import React, { useState } from 'react';
import PropTypes from 'prop-types';
import InventoryTable from './InventoryTable';
import { notify } from '../../Shared/toast';

// Move mock data to container level so it can be modified if needed
const MOCK_INVENTORY = [
  {
    id: 'mock-1',
    name: 'Basmati Rice',
    nameBn: 'বাসমতি চাল',
    category: 'Grains',
    quantity: 15,
    unit: 'kg',
    sellingPrice: 120,
    minStockLevel: 10,
  },
  {
    id: 'mock-2',
    name: 'Chicken',
    nameBn: 'মুরগি',
    category: 'Meat',
    quantity: 8,
    unit: 'kg',
    sellingPrice: 180,
    minStockLevel: 5,
  },
  {
    id: 'mock-3',
    name: 'Potato',
    nameBn: 'আলু',
    category: 'Vegetables',
    quantity: 25,
    unit: 'kg',
    sellingPrice: 30,
    minStockLevel: 15,
  },
];

function InventoryTableContainer({ enableDemoMode = false }) {
  const [inventoryItems, setInventoryItems] = useState([]);
  const [loading, setLoading] = useState(false); // Start with false since we're using local data

  // Simulate loading if needed
  const initializeData = () => {
    setLoading(true);
    setTimeout(() => {
      setInventoryItems(MOCK_INVENTORY);
      setLoading(false);
    }, 500); // Small delay to simulate async operation
  };

  // Initialize with mock data on first render
  React.useEffect(() => {
    initializeData();
  }, []);

  const handleDelete = (id) => {
    try {
      setInventoryItems((prev) => prev.filter((item) => item.id !== id));
      notify.success('Item deleted successfully');
    } catch (error) {
      notify.error('Delete failed');
    }
  };

  const handleEdit = (item) => {
    notify.info(`Editing item: ${item.name}`);
    // Implement actual edit logic here
  };

  const handleView = (id) => {
    notify.info(`Viewing item ID: ${id}`);
    // Implement actual view logic here
  };

  return (
    <div className="p-4">
      <h2 className="text-2xl font-bold mb-4">Inventory Management: Product List</h2>

      <div className="bg-blue-50 border-l-4 border-blue-400 p-4 mb-4">
        <p className="text-blue-700">
          Currently using demo data. API integration will be implemented later.
        </p>
      </div>

      <InventoryTable
        items={inventoryItems}
        onDelete={handleDelete}
        onEdit={handleEdit}
        onView={handleView}
        isLoading={loading}
        enableMockData={enableDemoMode}
        className="my-6"
      />
    </div>
  );
}

InventoryTableContainer.propTypes = {
  enableDemoMode: PropTypes.bool,
};

InventoryTableContainer.defaultProps = {
  enableDemoMode: false,
};

export default InventoryTableContainer;
